import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// Full-screen "under maintenance" page shown app-wide when Super Admin turns on
// Maintenance Mode. Pricing tools (/tools/*), resources (/resources/*) and tutorials
// stay reachable via the buttons below (the sidebar is hidden on this page); Super
// Admin is never blocked (so they can turn it off).
const PP = "'Poppins', sans-serif";

const LINKS = [
    { to: '/tools/rsc', label: 'RSC Calculator' },
    { to: '/tools/csc', label: 'CSC Calculator' },
    { to: '/resources/pricing', label: 'Resources' },
    { to: '/tutorials', label: 'Tutorials' },
    { to: '/user/profile', label: 'My Profile' },
];

export default function MaintenancePage() {
    const navigate = useNavigate();
    return (
        <Box sx={{
            minHeight: '100vh', display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', textAlign: 'center',
            p: 3, bgcolor: '#F8FAFC',
        }}>
            <img src="/nexwaveLogo.png" alt="Nexwave" style={{ width: 110, height: 'auto', marginBottom: 28 }} />
            <Typography sx={{ fontFamily: PP, fontWeight: 800, fontSize: '1.7rem', color: '#0F172A', mb: 1.25 }}>
                We&rsquo;ll be right back
            </Typography>
            <Typography sx={{ fontFamily: PP, fontSize: '0.95rem', color: '#64748B', maxWidth: 460, lineHeight: 1.6 }}>
                Nexwave is undergoing scheduled maintenance. We apologise for the inconvenience and will be
                back online shortly &mdash; thank you for your patience.
            </Typography>

            <Typography sx={{ fontFamily: PP, fontSize: '0.78rem', fontWeight: 600, color: '#94A3B8', mt: 3.5, mb: 1.25 }}>
                Still available during maintenance
            </Typography>
            <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap', justifyContent: 'center', maxWidth: 520 }}>
                {LINKS.map(l => (
                    <Button
                        key={l.to}
                        onClick={() => navigate(l.to)}
                        size="small"
                        variant="outlined"
                        sx={{ fontFamily: PP, textTransform: 'none', fontWeight: 600, fontSize: '0.8rem', borderRadius: '8px', borderColor: '#CBD5E1', color: '#1A8CFF' }}
                    >
                        {l.label}
                    </Button>
                ))}
            </Box>
        </Box>
    );
}
